import { LogService } from "../../../../shared/services/log.service";
import { Validator } from "../../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../../ctrl.name.extractor";

export class CTRL_1024 implements Validator {

    public static id = 'CTRL_1024';
    private message = 'error.ctr_1024_HorsDef';


    public LOG: LogService = new LogService(CTRL_1024);

    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_1024.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const adrCpNameWithStepId = map.get(ctrl.value.rgCtrls.adrCp);
                const adrCp_eNameWithStepId = map.get(ctrl.value.rgCtrls.adrCp_e);
                const adrPaysNameWithStepId = map.get(ctrl.value.rgCtrls.adrPays);
                const adrVilleNameWithStepId = map.get(ctrl.value.rgCtrls.adrVille);
                const adrVoieNomvoieNameWithStepId = map.get(ctrl.value.rgCtrls.adrVoieNomvoie);
                const adrVoieNumNameWithStepId = map.get(ctrl.value.rgCtrls.adrVoieNum);
                const adrVoieTypevoieNameWithStepId = map.get(ctrl.value.rgCtrls.adrVoieTypevoie);
                const adrVoie_eNomvoieNameWithStepId = map.get(ctrl.value.rgCtrls.adrVoie_eNomvoie);
                const adrVoie_eNumNameWithStepId = map.get(ctrl.value.rgCtrls.adrVoie_eNum);
                const adrVoie_eTypevoieNameWithStepId = map.get(ctrl.value.rgCtrls.adrVoie_eTypevoie);
                const coordFaxNameWithStepId = map.get(ctrl.value.rgCtrls.coordFax);
                const coordMelNameWithStepId = map.get(ctrl.value.rgCtrls.coordMel);
                const coordTelNameWithStepId = map.get(ctrl.value.rgCtrls.coordTel);
                const coordUrlNameWithStepId = map.get(ctrl.value.rgCtrls.coordUrl);
                const nomOfficielNameWithStepId = map.get(ctrl.value.rgCtrls.nomOfficiel);
                const codeIdentificationNationalNameWithStepId = map.get(ctrl.value.rgCtrls.codeIdentificationNational);
                const urlProfilAcheteurNameWithStepId = map.get(ctrl.value.rgCtrls.urlProfilAcheteur);
                const codeNUTSNameWithStepId = map.get(ctrl.value.rgCtrls.codeNUTS);
                const pointDeContactNameWithStepId = map.get(ctrl.value.rgCtrls.pointDeContact);

                const adrCpCtrl = form.controls[adrCpNameWithStepId];
                const adrCp_eCtrl = form.controls[adrCp_eNameWithStepId];
                const adrPaysCtrl = form.controls[adrPaysNameWithStepId];
                const adrVilleCtrl = form.controls[adrVilleNameWithStepId];
                const adrVoieNomvoieCtrl = form.controls[adrVoieNomvoieNameWithStepId];
                const adrVoieNumCtrl = form.controls[adrVoieNumNameWithStepId];
                const adrVoieTypevoieCtrl = form.controls[adrVoieTypevoieNameWithStepId];
                const adrVoie_eNomvoieCtrl = form.controls[adrVoie_eNomvoieNameWithStepId];
                const adrVoie_eNumCtrl = form.controls[adrVoie_eNumNameWithStepId];
                const adrVoie_eTypevoieCtrl = form.controls[adrVoie_eTypevoieNameWithStepId];
                const coordFaxCtrl = form.controls[coordFaxNameWithStepId];
                const coordMelCtrl = form.controls[coordMelNameWithStepId];
                const coordTelCtrl = form.controls[coordTelNameWithStepId];
                const coordUrlCtrl = form.controls[coordUrlNameWithStepId];
                const nomOfficielCtrl = form.controls[nomOfficielNameWithStepId];
                const codeIdentificationNationalCtrl = form.controls[codeIdentificationNationalNameWithStepId];
                const urlProfilAcheteurCtrl = form.controls[urlProfilAcheteurNameWithStepId];
                const codeNUTSCtrl = form.controls[codeNUTSNameWithStepId];
                const pointDeContactCtrl = form.controls[pointDeContactNameWithStepId];

                if (adrPaysCtrl.value === '' || adrPaysCtrl.value === null) {
                    if (adrCpCtrl.value === '' ||
                    adrPaysCtrl.value === '' ||
                    adrVilleCtrl.value === '' ||
                    nomOfficielCtrl.value === '' ||
                    adrVoieNomvoieCtrl.value === '' ||
                    adrVoieNumCtrl.value === '' ||
                    adrVoieTypevoieCtrl.value === '' ||
                    coordFaxCtrl.value === '' ||
                    coordMelCtrl.value === '' ||
                    coordTelCtrl.value === '' ||
                    coordUrlCtrl.value === '' ||
                    pointDeContactCtrl.value === '' ||
                    codeNUTSCtrl.value === '' ||
                    urlProfilAcheteurCtrl.value === '' ||
                    codeIdentificationNationalCtrl.value === '') {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    } else {
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    }
                } else {
                    if (adrCp_eCtrl.value === '' ||
                    adrPaysCtrl.value === '' ||
                    adrVilleCtrl.value === '' ||
                    nomOfficielCtrl.value === '' ||
                    adrVoie_eNomvoieCtrl.value === '' ||
                    adrVoie_eNumCtrl.value === '' ||
                    adrVoie_eTypevoieCtrl.value === '' ||
                    coordFaxCtrl.value === '' ||
                    coordMelCtrl.value === '' ||
                    coordTelCtrl.value === '' ||
                    coordUrlCtrl.value === '' ||
                    pointDeContactCtrl.value === '' ||
                    codeNUTSCtrl.value === '' ||
                    urlProfilAcheteurCtrl.value === '' ||
                    codeIdentificationNationalCtrl.value === '') {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    } else {
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    }
                }
            }
        }
    }
}